import React from "react";
import "./BlackScreen.css";

const BlackScreen = (props) => {
  return <div className="black-screen"></div>;
};

export default BlackScreen;
